import React from 'react';
import { TextInput } from 'hyperdb-utils';
import { UnitsFieldset } from '../../property/components';

const PropertyForm = ({ property, onChange, ...props }) => {
  const handleChange = (attributeName, field) => {
    const updatedAttributes = { ...property, [attributeName]: field.value };
    onChange(updatedAttributes);
  };
  const handleChangeUnits = (units) => {
    handleChange('units', { value: units });
  };
  const units = (property.units || []).slice();
  units.sort((a, b) => a.number - b.number);
  return (
    <fieldset>
      <TextInput
        label="name"
        name="name"
        value={ property.name }
        onChange={ handleChange.bind(null, 'name') }
      />
      <TextInput
        label="remote_id"
        name="remote_id"
        value={ property.remote_id }
        onChange={ handleChange.bind(null, 'remote_id') }
      />
      {
        property.multi_unit === 2
          ? <UnitsFieldset { ...props } units={ units } onChange={ handleChangeUnits } showRemoteId={ true } />
          : null
      }
    </fieldset>
  );
};

export default PropertyForm;



// WEBPACK FOOTER //
// ./src/frontend/modules/inventory/channel/components/PropertyForm.jsx